import styled from 'styled-components';
import Typography from '../../typography/Typography';
export const SwapsSummaryWrapper = styled.div `
  display: flex;
  flex-direction: column;

  padding-top: 2.2rem;

  ${({ theme }) => theme.media.tabletS `
    align-items: center;
  `}

  ${({ theme }) => theme.media.tabletL `
    padding-top: 3.2rem;
  `}
`;
export const SwapsSummaryTitle = styled(Typography) `
  margin-bottom: 1.6rem;
  align-self: center;

  ${({ theme }) => theme.media.tabletL `
    margin-bottom: 2.2rem;
  `}
`;
export const SwapsSummary = styled.div `
  display: flex;
  align-items: center;
  flex-direction: column;
  ${({ theme }) => theme.media.tabletS `
   flex-direction: row;
`}
`;
export const BorderWrapper = styled.div `
  display: flex;
  align-items: center;
  padding: 0 2rem;
  justify-content: center;

  border: 0.1rem solid ${({ theme }) => theme.colors.borders.default};
  border-radius: ${({ theme }) => theme.borderRadius.medium};

  ${({ theme }) => theme.media.tabletL `
   padding: 0 4rem;
`}

  width: 100%;
  ${({ theme }) => theme.media.tabletS `
   width: inherit;
`}
`;
export const ResultWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 0.6rem 1rem;

  ${({ theme }) => theme.media.tabletL `
    padding: 1.6rem;
  `}
`;
export const CustomTypography = styled(Typography) `
  text-align: center;
`;
export const ResultAssetWrapper = styled.div `
  display: flex;
  align-items: center;

  margin-top: 0.4rem;

  img {
    height: 2.5rem;
  }

  ${({ theme }) => theme.media.tabletL `
    margin-top: 0.8rem;

    img {
      height: 3.6rem;
    }
  `}
`;
export const IconWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;

  width: 2.6rem;
  height: 2.6rem;

  margin: 0.6rem 0;

  border-radius: ${({ theme }) => theme.borderRadius.highest};

  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};

  rotate: 90deg;

  ${({ theme }) => theme.media.tabletS `
   rotate: unset;
   margin: 0 0.6rem;

   
  `}
`;
export const Line = styled.div `
  height: 3rem;

  border: 1px solid ${({ theme }) => theme.colors.borders.default};

  ${({ theme }) => theme.media.tabletL `
    height: 5rem;
  `}
`;
//# sourceMappingURL=styles.js.map